import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { PromoPartnerFamily } from 'src/app/assabil-sales/models/entities/promo-partner-family.entity';
import { PromoPartnerFamilyPartner } from 'src/app/assabil-sales/models/entities/promo-partner-family-partner.entity';
import { PromoService } from 'src/app/assabil-sales/services/pomo-service';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'promo-partner-family-widget',
    templateUrl: './promo-partner-family-widget.component.html',
    styleUrls: ['./promo-partner-family-widget.component.scss']
})

export class PromoPartnerFamilyWidgetComponent extends BaseWidget {

  promoPartnerFamily      : PromoPartnerFamily = new PromoPartnerFamily();

  partnerColumns = [
    { prop: 'partner.partnerCode',  name: 'Code',  readOnly : true },
    { prop: 'partner.name',         name: 'Nom',   readOnly : true  },
  ]


  constructor(
      protected promoService      : PromoService,
      protected toastr            : ToastrService,
      protected dialog            : MatDialog,
      protected leanUtilsService  : LeanUtilsService) {
      super(toastr, leanUtilsService);
  //    this.partnerCategoryTypeContainer = new EntityContainer(PartnerCategoryType);
  }


//-----------------------------------------------------------------------------------------------------------------------------
 setEntity(promoPartnerFamily: PromoPartnerFamily) {
      this.promoPartnerFamily  = { ...promoPartnerFamily };
      this.promoPartnerFamily.promoPartnerFamilyPartners = [];
      if (promoPartnerFamily.promoPartnerFamilyPartners) {
        for (let promoPartnerFamilyPartner of promoPartnerFamily.promoPartnerFamilyPartners) {
          this.promoPartnerFamily.promoPartnerFamilyPartners.push({ ...promoPartnerFamilyPartner });
        }
      }
  }
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
 getEntity(){
    return this.promoPartnerFamily;
  }
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
saveRow() : Promise<PromoPartnerFamily>{
    return this.promoService.promoPartnerFamilySave(this.promoPartnerFamily);
  }
//-----------------------------------------------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
  partners : Partner[];
  new(){

    let dialogRef = this.dialog.open(PartnerLovComponent, {autoFocus: false,  hasBackdrop : false,  data : {dual: true, partners  : this.partners}});
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.partners = result.partners;
        if (result.selectedPartners) this.addPartners(result.selectedPartners);
      }
    });
  }
//-----------------------------------------------------------------------------------------------------------------------------


 //-----------------------------------------------------------------------------------------------------------------------------
 addPartners(partners : Partner[]){
    for (let partner of partners){

      // Ignore partner if already exists in the list
      //-----------------------------------------------------------------------------
        let found : boolean = false;
        for (let x of this.promoPartnerFamily.promoPartnerFamilyPartners){
          if (x.partner.partnerCode === partner.partnerCode) {
            found = true;
            break
          }
        } 
        if (found){
          continue;
        }
        //-----------------------------------------------------------------------------

        let nr = new PromoPartnerFamilyPartner();
        nr.inserted = true;
        nr.edit      = true;
        nr.promoPartnerFamilyCode = this.promoPartnerFamily.promoPartnerFamilyCode;
        nr.partner  = new Partner();
        nr.partner.partnerCode  = partner.partnerCode;
        nr.partner.name         = partner.name;
        this.promoPartnerFamily.promoPartnerFamilyPartners.push(nr);
    }
    this.promoPartnerFamily.promoPartnerFamilyPartners = [...this.promoPartnerFamily.promoPartnerFamilyPartners];  
  }
//-----------------------------------------------------------------------------------------------------------------------------

}
